/** @format */
import process from "process";

const API_BASE_URL = process.env.REACT_APP_API_URL; 

export async function getInstance(token, modelId = null) {
  const apiUrl = `${API_BASE_URL}/process/list/full`;

  const body = modelId ? { ModelId: modelId } : {};
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json", 
        Authorization: token,
      },
      body: JSON.stringify(body), 
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.message.list;
  } catch (error) {
    throw new Error(error);
  }
}